import type { SVGProps } from 'react'

const SvgBlipNew = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>Blip New</title>
    <path
      d="m.247 10.212 5.02-8.697a2 2 0 0 1 3.465 0l5.021 8.697a2 2 0 0 1-1.732 3H1.98a2 2 0 0 1-1.732-3z"
      fill="currentColor"
    />
  </svg>
)
export default SvgBlipNew
